<template>
    <div class="login-module">
        <div class="login-tab">
            <!-- <div class="close-btn" @click="close">
                <span class="iconfont icon-a-CombinedShape4" style="font-size: 12px;"></span>
            </div> -->
            <p class="login-textc">手机号验证</p>
            <p class="login-texte">VERIFICATION</p>
            <el-form :model="editForm" label-width="100px" ref="editForm">
                <div class="login-input">
                    <div class="phoneinput">
                        <div class="phone">
                            <img src="../../assets/images/shouji.png" alt />
                        </div>
                        <div class="c-input">
                            <el-form-item type="primary">
                                <el-input oninput="value=value.replace(/\D/g, '')" :disabled="true" maxlength="11"
                                    placeholder="请输入手机号码" @input="disabledcodeClick" @blur="verifyBlur"
                                    v-model="editForm.username" autofocus>
                                </el-input>
                            </el-form-item>
                            <div class="errorhint" v-show="errorhint">{{errorhinttext}}</div>
                        </div>
                    </div>

                    <div class="phoneinput">
                        <div class="phone">
                            <img src="../../assets/images/wangji.png" alt />
                        </div>
                        <div class="b-input">
                            <div class="codeinput">
                                <el-form-item type="primary">
                                    <el-input placeholder="请输入验证码" @input="disabledcodeClick" maxlength="4"
                                        v-model="editForm.code"></el-input>
                                </el-form-item>
                                <div class="errorhint" v-show="errorhintCode">{{errorhinttextCode}}</div>
                            </div>

                            <div class="codebtn">
                                <el-button type="primary"
                                    :class="[disabled==false?'el-button--primary':'el-button--primaryno']"
                                    :disabled="disabled" @click="verification">{{btntxt}}</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="register wxeducationFill">
                        <el-button :disabled="nextdisabled" @click.native.prevent="nextstepClick">验证
                        </el-button>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
    import AES from '@/utils/AES'
    import HintPrompt from "@/components/wx-hintprompt";
    import { forgetPasswordCode, getForgetPassCode, imgCaptcha, login, isUse, userById, disabled, authentication } from "@/api/login";
    import {
        setToken,
        setUuid,
        setroleId,
        setschoolId,
        setuserName,
        setuserPhone,
        setheadPath,
        setschoolCode,
        setrank,
        setIsAdmin,
        setorganFlag
    } from "@/utils/auth";
    import { info } from "@/api/province_Resource"
    import { menuButtonByToken } from "@/api/power";
    import { filterNUmber } from "@/utils/validate"
    export default {
        props: {
            loginparameters: {
                type: Object,
                default: () => { },
            },
        },
        data() {
            return {
                timeout: null,
                timea: null,
                markedwords: "", //提示框文字
                errorhint: false,
                errorhinttext: "",
                errorhintCode: false,
                errorhinttextCode: "",
                editForm: {
                    username: this.loginparameters.username,
                    code: "",
                },
                nextdisabled: true, //下一步颜色
                disabled: false, //灰色
                time: 0, //验证码时间

                btntxt: "获取验证码",
                logindata: this.loginparameters,
            };
        },
        computed: {},
        methods: {
            //失去焦点验证手机格式
            verifyBlur() {
                let phoneInt = /^1[3456789]\d{9}$/;
                if (this.editForm.username == "") {
                    this.errorhint = true;
                    this.errorhinttext = "请输入手机号码";
                } else if (phoneInt.test(this.editForm.username) == false) {
                    this.errorhint = true;
                    this.errorhinttext = "手机号码格式不正确";
                } else {
                    this.errorhint = false;
                }
            },
            //手机号 验证码输入判断
            disabledcodeClick() {
                //下一步按钮判断
                if (this.editForm.code != "" && this.editForm.username != "") {
                    this.nextdisabled = false;
                } else {
                    this.nextdisabled = true;
                }
                let phoneInt = /^1[3456789]\d{9}$/;
                let captcha = /^\d{4}$/;
                //验证码按钮判断
                if (this.editForm.username != "") {
                    this.errorhint = false;
                    if (this.time == 0) {
                        this.disabled = false;
                    }
                } else {
                    this.disabled = true;
                    this.errorhint = false;
                }
            },
            nextstepClick() {
                //验证注册账号
                let phoneInt = /^1[3456789]\d{9}$/;
                let captcha = /^\d{4}$/;
                if (this.editForm.username == "") {
                    this.errorhint = true;
                    this.errorhinttext = "请输入手机号码";
                } else if (phoneInt.test(this.editForm.username) == false) {
                    this.errorhint = true;
                    this.errorhinttext = "手机号码格式不正确";
                } else if (this.editForm.code == "") {
                    this.errorhintCode = true;
                    this.errorhinttextCode = "请输入验证码";
                } else if (captcha.test(this.editForm.code) == false) {
                    this.errorhintCode = true;
                    this.errorhinttextCode = "验证码格式错误";
                } else {
                    this.errorhintCode = false;
                    this.errorhint = false;

                    forgetPasswordCode(this.editForm).then((res) => {
                        if (res.code === 200) {
                            this.loginbtn();
                        } else if (res.code === 3000) {
                            this.errorhint = true;
                            this.errorhinttext = "验证码错误";
                        }
                    });
                }
            },
            loginbtn() {
                let add = JSON.parse(localStorage.userDate)
                login(add).then((loginres) => {
                    if (loginres.code === 200) {
                        // localStorage.clear();
                        localStorage.setItem('pageSize', 10);
                        setToken(loginres.data.token);
                        setUuid(loginres.data.user.uuid);
                        localStorage.setItem('userId', loginres.data.user.uuid);
                        this.logintext = "登录中...";
                        let userobj = {
                            userId: loginres.data.user.uuid
                        }
                        info(userobj).then((res) => {
                            if (res.code === 200) {
                                setorganFlag(res.data.organFlag);
                                localStorage.subjectId = res.data.subjectId;
                                localStorage.subjectname = res.data.subjectName;
                            }
                        });
                        this.userbid(loginres)
                        // 2010
                    } else {
                        this.errorhint = true;
                        this.errorhinttext = loginres.msg;
                        this.img_code();
                    }
                });
            },
            registerClick() {
                this.logindata.logindata = true;
                this.logindata.forgetdata = false;
                this.logindata.settingdata = false;
                this.logindata.defaultdata = false;
                this.logindata.Ipstate = false;
            },

            verification() {
                let phoneInt = /^1[3456789]\d{9}$/;
                let captcha = /^\d{4}$/;
                if (phoneInt.test(this.editForm.username) == false) {
                    this.errorhint = true;
                    this.errorhinttext = "手机号码格式不正确";
                    return false
                }
                isUse(this.editForm.username).then((res) => {
                    if (res.data == 1) {
                        getForgetPassCode(this.editForm.username).then((res) => {
                            if (res.code === 200) {
                                this.time = 60;
                                this.disabled = true;
                                this.hintpromptstate = true;
                                this.markedwords = "验证码发送成功";
                                this.timeout = setTimeout(() => {
                                    this.hintpromptstate = false;
                                }, 1000);
                                // this.$message({
                                //   message: "验证码发送成功",
                                //   type: "success",
                                //   center: true,
                                // });
                                this.timer();
                            }
                        });
                    } else if (res.data == 0) {
                        this.errorhint = true;
                        this.errorhinttext = "账号不存在";
                    }
                });
            },
            timer() {
                if (this.time > 0) {
                    this.time--;
                    this.btntxt = this.time + "s";
                    this.timea = setTimeout(this.timer, 1000);
                } else {
                    this.time = 0;
                    this.btntxt = "获取验证码";
                    let phoneInt = /^1[3456789]\d{9}$/;
                    if (
                        this.editForm.username != "" &&
                        phoneInt.test(this.editForm.username) == true
                    ) {
                        this.disabled = false;
                    } else {
                        this.disabled = true;
                    }
                }
            },
            userbid(loginres) {
                userById(loginres.data.user.uuid).then((userres) => {
                    //   //这里到时候判断schoolCode
                    // if ( userres.data.schoolId != "" ||userres.data.userId == 1) {
                    setuserPhone(userres.data.username);
                    setroleId(userres.data.roleId);
                    setuserName(userres.data.name);
                    setschoolId(userres.data.aff);
                    setrank(userres.data.roleLevel);
                    setIsAdmin(userres.data.isAdmin)
                    setheadPath(userres.data.headPath);
                    setschoolCode(userres.data.schoolCode);
                    // 截取手机号后六位
                    // const usertel = this.editForm.username.substring(this.editForm.username.length - 6);
                    // usertel === this.editForm.password
                    // Ipstate
                    this.$store.commit('loginState', false);
                    let paurl = localStorage.appointPath;
                    if (userres.data.userId == 1) {
                        localStorage.setItem(
                            "routerpath",
                            JSON.stringify("/group/probable")
                        );
                        // setTimeout(() => {
                        if (paurl) {
                            this.$router.replace({ path: paurl });
                        } else {
                            this.$router.replace({ path: "/group/probable" });
                        }
                        this.hintpromptstate = false;
                        this.cun(userres);
                        // }, 800);
                        // this.hintpromptstate = true;
                        // this.markedwords = "登录成功";
                    } else {
                        // localStorage.appointPath
                        localStorage.setItem(
                            "routerpath",
                            JSON.stringify("/group/personal")
                        );
                        // setTimeout(() => {
                        if (paurl) {
                            this.$router.replace({ path: paurl });
                        } else {
                            this.$router.replace({ path: "/group/personal" });
                        }
                        this.hintpromptstate = false;
                        this.cun(userres);
                        // }, 800);
                        // this.hintpromptstate = true;
                        // this.markedwords = "登录成功";
                    }
                });
            },
            cun(userres) {
                //存储权限按钮
                menuButtonByToken(userres.data.roleId).then((menuButtonres) => {
                    if (menuButtonres.code === 200) {
                        let buttons = menuButtonres.data;
                        localStorage.setItem(
                            "ButtonPermissions",
                            JSON.stringify(buttons)
                        );
                        // setTimeout(() => {
                        // }, 500)
                        localStorage.removeItem('defaultdata');
                        localStorage.removeItem('userDate');
                        location.reload()
                    }
                });
                localStorage.removeItem('user')
            },
            handleTab() {
                this.$emit('login')
            },
            close() {
                // this.$store.commit('loginState', false);
                this.registerClick();
            },
        },
        mounted() {
        },
        destroyed() { },
        created() {
        },
        updated() { },
        beforeDestroy(){
            clearTimeout(this.timeout)
            clearTimeout(this.timea)
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import './index.styl';
</style>



// WEBPACK FOOTER //
// src/components/IP_verification/index.vue